var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.40967,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#2884FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.725 9.46167C14.6617 8.39832 14.6617 6.67429 15.725 5.61093L20.5384 0.797513C21.6018 -0.265838 23.3258 -0.265838 24.3892 0.797514L29.2026 5.61093C30.2659 6.67429 30.2659 8.39832 29.2026 9.46167L24.3892 14.2751C23.3258 15.3384 21.6018 15.3384 20.5384 14.2751L15.725 9.46167Z",
    fill: "#2884FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 17.7471,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#2884FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3374,
    y: 17.7471,
    width: 12.253,
    height: 12.253,
    rx: 2,
    fill: "#2884FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternIconSelected);
export default __webpack_public_path__ + "static/media/pattern-icon-selected.143e6f129fdd76d1a933a02d8e9c4e15.svg";
export { ForwardRef as ReactComponent };